import { RG68_06 } from "./RG68_06"

export const RG68 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Sales Performance by District Manager",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Employee Code',
                        "columnName": 'EmployeeCode',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'District Manager Name',
                        "columnName": 'DistrictManagerName',
                        "width": '250px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Region',
                        "columnName": 'RegionCode',
                        "width": '100px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'District Name',
                        "columnName": 'DistrictName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Target',
                        "columnName": 'TargetSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Performance %',
                        "columnName": 'Performance',
                        "width": '150px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "DistrictManagerName",
                "endpoint": "RG68",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "RegionCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": RG68_06
                }
            }
        }
    }
}